import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = [
    "input",
    "item",
    "group"
  ]

  static values = {
    mode: String,
    url: String
  }

  connect() {
    this.timeout = null
  }

  perform() {
    if (this.modeValue === "local") {
      this.performLocalSearch()
      return
    }

    if (this.modeValue === "remote") {
      this.performRemoteSearch()
    }
  }

  performLocalSearch() {
    const query = this.inputTarget.value
      .toLowerCase()
      .trim()

    this.itemTargets.forEach((item) => {
      const key = item.dataset.searchKey

      const visible = key.includes(query)

      item.classList.toggle("hidden", !visible)
    })

    this.groupTargets.forEach((group) => {
      const visibleChildren =
        group.querySelectorAll(
          '[data-search-target="item"]:not(.hidden)'
        )

      const hasVisibleChildren = visibleChildren.length > 0

      group.classList.toggle("hidden", !hasVisibleChildren)

      if (hasVisibleChildren && query.length > 0) {
        group.setAttribute("open", "")
      } else {
        group.removeAttribute("open")
      }
    })
  }

  performRemoteSearch() {
    clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      const query = this.inputTarget.value.trim()

      const url = new URL(this.urlValue, window.location.origin)

      if (query.length > 0) {
        url.searchParams.set("external_id", query)
      }

      Turbo.visit(url.toString(), {
        frame: "event_search_result"
      })
    }, 300)
  }
}